import * as Parsimmon from 'parsimmon';

export const HiddenFieldsLang = Parsimmon.createLanguage({
  Statement: function (r) {
    return r.FieldName.sepBy1(Parsimmon.string(',').skip(Parsimmon.optWhitespace)).wrap(
      Parsimmon.string('['),
      Parsimmon.string(']')
    );
  },

  FieldName: function () {
    const escapedChar = Parsimmon.string('\\')
      .then(Parsimmon.any)
      .map((c) => c);
    const normalChar = Parsimmon.noneOf("'");
    const content = Parsimmon.alt(escapedChar, normalChar);

    return Parsimmon.string("'")
      .then(content.many().map((chars) => chars.join('')))
      .skip(Parsimmon.string("'"))
      .skip(Parsimmon.optWhitespace);
  },
});
